/** Hide the redundant inline copy when the field already shows "Required". */
export function inlineCompanyFieldIssues(
  header: string,
  reasons: string[]
): string[] {
  const requiredMessage = `"${header}" is required.`;
  return reasons.filter((message) => message !== requiredMessage);
}
